import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("fabrication");
  const [activeGallery, setActiveGallery] = useState(null);
  const [activeSection, setActiveSection] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  // Scroll spy for navbar highlight
  useEffect(() => {
  const handleScroll = () => {
    const sections = document.querySelectorAll("section");
    const scrollY = window.scrollY + 120;
    sections.forEach((sec) => {
      if (scrollY >= sec.offsetTop && scrollY < sec.offsetTop + sec.offsetHeight) {
        setActiveSection(sec.getAttribute("id"));
      }
    });
  };

  // Smooth scroll for menu clicks
  const links = document.querySelectorAll(".nav-links a");
  links.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href").substring(1);
      const target = document.getElementById(targetId);

      if (target) {
        window.scrollTo({
          top: target.offsetTop - (targetId === "home" ? 0 : 80), // offset except for home
          behavior: "smooth"
        });
      }
    });
  });

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
    links.forEach(link => {
      link.removeEventListener("click", () => {}); // cleanup
    });
  };
}, []);


  // Mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu when clicking on a link
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Netlify Forms Handler
  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const formDataToSend = new URLSearchParams({
        'form-name': 'contact',
        'name': formData.name,
        'email': formData.email,
        'message': formData.message,
      });

      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formDataToSend
      });

      // Netlify Forms returns HTML page, check for success indicators
      if (response.ok) {
        const responseText = await response.text();
        // Check if the response indicates success (Netlify Forms returns HTML)
        if (responseText.includes('Thank you') || responseText.includes('success') || response.status === 200) {
          setStatus("✅ Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        } else {
          setStatus("✅ Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        }
      } else {
        setStatus("❌ Failed to send. Please try again later.");
      }
    } catch (error) {
      console.error('Form Error:', error);
      setStatus("❌ Failed to send. Please try again later.");
    }
  };

  // Fabrication images
  const fabricationImages = [
    "AYASKA ENG. FABRICATION_p1_2.jpg",
    "AYASKA ENG. FABRICATION_p4_6.jpg",
    "AYASKA ENG. FABRICATION_p8_6.jpeg",
    "AYASKA ENG. FABRICATION_p9_6.jpeg",
    "AYASKA ENG. FABRICATION_p10_6.jpeg",
    "AYASKA ENG. FABRICATION_p10_7.jpeg",
    "AYASKA ENG. FABRICATION_p10_8.jpeg",
    "AYASKA ENG. FABRICATION_p11_6.jpeg",
    "AYASKA ENG. FABRICATION_p11_7.jpeg",
    "AYASKA ENG. FABRICATION_p12_6.jpeg",
    "AYASKA ENG. FABRICATION_p13_6.jpeg",
    "AYASKA ENG. FABRICATION_p13_7.jpeg",
    "AYASKA ENG. FABRICATION_p13_8.jpeg",
    "AYASKA ENG. FABRICATION_p14_6.jpeg",
    "AYASKA ENG. FABRICATION_p14_7.jpeg",
    "AYASKA ENG. FABRICATION_p15_6.jpeg",
    "AYASKA ENG. FABRICATION_p16_6.jpeg",
    "AYASKA ENG. FABRICATION_p17_6.jpeg",
    "AYASKA ENG. FABRICATION_p18_6.jpeg",
    "AYASKA ENG. FABRICATION_p19_6.jpeg",
    "AYASKA ENG. FABRICATION_p21_6.jpeg",
    "AYASKA ENG. FABRICATION_p21_8.jpeg",
    "AYASKA ENG. FABRICATION_p22_8.jpeg",
    "AYASKA ENG. FABRICATION_p23_7.jpeg",
    "AYASKA ENG. FABRICATION_p24_8.jpeg",
    "AYASKA ENG. FABRICATION_New_1.jpg",
    "AYASKA ENG. FABRICATION_New_2.jpg",
    "AYASKA ENG. FABRICATION_New_3.jpg",
    "AYASKA ENG. FABRICATION_New_4.jpg",
    "AYASKA ENG. FABRICATION_New_5.jpg",
    "AYASKA ENG. FABRICATION_New_6.jpg",
    "AYASKA ENG. FABRICATION_New_7.jpg",
    "AYASKA ENG. FABRICATION_New_8.jpg",
  ];

  // Infrastructure images
  const infrastructureImages = [
    "AYASKA_PROFILE_INFRA_p1_1.jpeg",
    "AYASKA_PROFILE_INFRA_p1_2.jpeg",
    "AYASKA_PROFILE_INFRA_p1_3.jpeg",
    "AYASKA_PROFILE_INFRA_p3_1.jpeg",
    "AYASKA_PROFILE_INFRA_p4_1.jpeg",
    "AYASKA_PROFILE_INFRA_p5_1.jpeg",
    "AYASKA_PROFILE_INFRA_p6_1.jpeg",
    "AYASKA_PROFILE_INFRA_p8_1.jpeg",
    "AYASKA_PROFILE_INFRA_p9_1.jpeg",
    "AYASKA_PROFILE_INFRA_p9_2.jpeg",
    "AYASKA_PROFILE_INFRA_p10_1.jpeg",
  ];

  // Infrastructure cards
  const infraCardImages = [
    { file: "infra-cnc.jpg", label: "CNC & Manual Cutting Machines" },
    { file: "infra-plasma.jpg", label: "Plasma Cutting" },
    { file: "infra-pug.jpg", label: "Pug Cutting Machine" },
    { file: "infra-welding.jpg", label: "MIG & ARC Welding Machines" },
    { file: "infra-drill.jpg", label: "Magnetic Drills & Broach Cutters" },
    { file: "infra-grinder.jpg", label: "Grinders (4” & 7”)" },
    { file: "iron-worker.jpg", label: "Iron Worker" }
  ];

  // Pick current gallery
  let currentGallery = [];
  if (activeGallery === "fabrication") currentGallery = fabricationImages;
  if (activeGallery === "infrastructure") currentGallery = infrastructureImages;
  if (activeGallery === "infraCards") currentGallery = infraCardImages.map(i => i.file);

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar">
        <img src="/images/logo.png" alt="Ayaska Engineering" className="nav-logo" />
        
        {/* Hamburger Menu Button */}
        <button 
          className="hamburger-menu" 
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
        </button>

        {/* Desktop Navigation */}
        <ul className="nav-links">
          <li><a href="#home" className={activeSection === "home" ? "active" : ""} onClick={closeMobileMenu}>Home</a></li>
          <li><a href="#about" className={activeSection === "about" ? "active" : ""} onClick={closeMobileMenu}>About</a></li>
          <li><a href="#services" className={activeSection === "services" ? "active" : ""} onClick={closeMobileMenu}>Services</a></li>
          <li><a href="#infra" className={activeSection === "infra" ? "active" : ""} onClick={closeMobileMenu}>Infrastructure</a></li>
          <li><a href="#clients" className={activeSection === "clients" ? "active" : ""} onClick={closeMobileMenu}>Clients</a></li>
          <li><a href="#gallery" className={activeSection === "gallery" ? "active" : ""} onClick={closeMobileMenu}>Gallery</a></li>
          <li><a href="#contact" className={activeSection === "contact" ? "active" : ""} onClick={closeMobileMenu}>Contact</a></li>
        </ul>

        {/* Mobile Navigation Overlay */}
        <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-nav-links">
            <li><a href="#home" className={activeSection === "home" ? "active" : ""} onClick={closeMobileMenu}>Home</a></li>
            <li><a href="#about" className={activeSection === "about" ? "active" : ""} onClick={closeMobileMenu}>About</a></li>
            <li><a href="#services" className={activeSection === "services" ? "active" : ""} onClick={closeMobileMenu}>Services</a></li>
            <li><a href="#infra" className={activeSection === "infra" ? "active" : ""} onClick={closeMobileMenu}>Infrastructure</a></li>
            <li><a href="#clients" className={activeSection === "clients" ? "active" : ""} onClick={closeMobileMenu}>Clients</a></li>
            <li><a href="#gallery" className={activeSection === "gallery" ? "active" : ""} onClick={closeMobileMenu}>Gallery</a></li>
            <li><a href="#contact" className={activeSection === "contact" ? "active" : ""} onClick={closeMobileMenu}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero */}
      <section
        id="home"
        className="hero"
        style={{
          backgroundImage: `linear-gradient(rgba(10,61,98,0.55), rgba(10,61,98,0.55)), url(${process.env.PUBLIC_URL}/images/mig-hero.jpg)`,
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">Innovative Fabrication &amp; Infrastructure Solutions</h1>
          <p className="hero-sub">Delivering precision, durability, and innovation for over 12 years.</p>
          <a href="#contact" className="btn-primary hero-cta">Get in Touch</a>
        </div>
      </section>

      {/* About */}
      <section id="about" className="section about">
        <h2>About Us</h2>
        <div className="about-text">
          <p><strong>AYASKA ENGINEERING</strong> is a dynamic fabrication company committed to delivering high-quality and precision-engineered solutions. With a strong foundation built on 12 years of industry experience, our team specializes in customized fabrication services tailored to meet the needs of various industries.</p>
          <p>We are driven by a highly motivated team of professionals whose exposure in fabrication, machining, and structural work can guide in selecting and manufacturing products that meet the latest industrial standards.</p>
          <p>At Ayaska Engineering, we prioritize innovation, durability and precision, ensuring that every project meets the highest standards. Our expertise, combined with advanced technology and skilled craftsmanship, enables us to provide reliable and efficient solutions for our clients.</p>
          <p>We believe in building long-term relationships through quality workmanship, timely delivery and excellent customer satisfaction.</p>
        </div>

        {/* Horizontal Objective/Goal/Mission/Vision */}
        <div className="about-cards">
          <div className="about-card"><h3>Objective</h3><p>Provide high-quality, precision-engineered fabrication solutions that meet evolving demands while maintaining efficiency and customer satisfaction.</p></div>
          <div className="about-card"><h3>Goal</h3><p>Become a trusted leader in the fabrication industry by delivering superior products, expanding expertise and improving processes continuously.</p></div>
          <div className="about-card"><h3>Mission</h3><p>Deliver custom fabrication solutions with precision and innovation while ensuring excellence in craftsmanship, satisfaction and sustainable growth.</p></div>
          <div className="about-card"><h3>Vision</h3><p>Be recognized as a company known for reliability, innovation and engineering excellence, setting new benchmarks in quality and trust.</p></div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="section services">
        <h2>Our Services</h2>
        <div className="cards-grid services-grid">
          <div className="service-card">
            <span className="service-icon">⚙️</span>
            <h3>Fabrication</h3>
            <ul>
              <li>All types of fabrication & machining</li>
              <li>Belt conveyors, structures, frames</li>
              <li>Hoppers, ducts, air slides</li>
              <li>Manual & diverting gates</li>
              <li>Structural works of all types</li>
            </ul>
          </div>
          <div className="service-card">
            <span className="service-icon">🏗️</span>
            <h3>Infrastructure</h3>
            <ul>
              <li>Road construction & maintenance</li>
              <li>Drainage systems & patch works</li>
              <li>Road safety installations</li>
              <li>Thermoplastic road marking</li>
              <li>Electrical & road lighting</li>
              <li>Tiles, barriers, culverts</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Infrastructure Cards */}
      <section id="infra" className="section">
        <h2>Infrastructure & Machinery</h2>
        <div className="infrastructure-grid">
          {infraCardImages.map((item, index) => (
            <div key={index} className="infra-card-wrapper">
              <div
                className="infra-card"
                style={{ backgroundImage: `url(/images/${item.file})` }}
                onClick={() => {
                  setActiveGallery("infraCards");
                  setCurrentIndex(index);
                }}
              />
              <div className="infra-caption">{item.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Clients */}
      <section id="clients" className="section">
        <h2>Our Clients</h2>
        <div className="cards-grid">
          <div className="card">NHAI</div>
          <div className="card">SREPL</div>
          <div className="card">PATEL INFRA</div>
          <div className="card">PUZZOLANA</div>
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" className="section gallery">
        <h2>Project & Machine Gallery</h2>
        <div className="tabs">
          <button
            className={activeTab === "fabrication" ? "active" : ""}
            onClick={() => { setActiveTab("fabrication"); setCurrentIndex(null); }}
          >
            Fabrication
          </button>
          <button
            className={activeTab === "infrastructure" ? "active" : ""}
            onClick={() => { setActiveTab("infrastructure"); setCurrentIndex(null); }}
          >
            Infrastructure & Machinery
          </button>
        </div>

        <div className="gallery-grid">
          {(activeTab === "fabrication" ? fabricationImages : infrastructureImages).map((file, index) => (
            <img
              key={index}
              src={`/images/${file}`}
              alt={`Gallery ${index + 1}`}
              onClick={() => {
                setActiveGallery(activeTab);
                setCurrentIndex(index);
              }}
            />
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {currentIndex !== null && currentGallery.length > 0 && (
        <div className="lightbox">
          <span className="close" onClick={() => setCurrentIndex(null)}>&times;</span>
          <span className="prev" onClick={() => setCurrentIndex((currentIndex - 1 + currentGallery.length) % currentGallery.length)}>
            &#10094;
          </span>
          <img src={`/images/${currentGallery[currentIndex]}`} alt="Large view" />
          <span className="next" onClick={() => setCurrentIndex((currentIndex + 1) % currentGallery.length)}>
            &#10095;
          </span>
          {activeGallery === "infraCards" && (
            <div className="caption">{infraCardImages[currentIndex].label}</div>
          )}
        </div>
      )}

      {/* Contact */}
      <section id="contact" className="section contact">
        <h2>Contact Us</h2>
        <p><b>Address:</b> E-2, NH 48, Industrial area Jaipur(Raj.)</p>
        <p><b>Phone:</b> +91-9352598521</p>
        <p><b>Email:</b> info@ayaskaengineering.com</p>
        <form name="contact" method="POST" netlify netlify-honeypot="bot-field" onSubmit={sendEmail}>
          <input type="hidden" name="form-name" value="contact" />
          <input type="hidden" name="bot-field" />
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            required
          />
          <button type="submit">Send Message</button>
        </form>
        {status && <p className="status">{status}</p>}
      </section>

      {/* Footer */}
      <footer>
        <p>© {new Date().getFullYear()} Ayaska Engineering. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
